let formNode;

$('.business_custom_form').parents('.shopify-section').addClass('contact-us-section').attr('id', 'contact_us_block');

function showForm() {
  $('html').css('overflow', 'hidden');
  $('.contact-us-section').fadeIn();
}

function hideForm() {
  $('.contact-us-section').fadeOut();
  $('html').css('overflow', 'auto');
}

$('a[href^="#contact_us_block"]').on('click', function(){
  // showForm();
  $('#corporateFormBtn').trigger('click');
  console.log('a');
});

$('.close-contact-form').on('click', function(){
  hideForm();
});

document.addEventListener('click', function(e){
  var el = e.target;

  if (el.matches('.fserv-button-submit')) {
    formNode = document.querySelector(".fs-notifier");
  
    onClassChange(formNode, (observer) => {
      if (formNode.classList.contains('visible')) {
        $('#business_form form').slideUp();
        $('.fserv-form-name, .fserv-form-description').hide();
        
        setTimeout(function() {
          hideForm();
          $('.fserv-form-name, .fserv-form-description').show();
          $('#business_form form').fadeIn();
          $('.fs-notifier').removeClass('show-notification visible');
        }, 5000);
      }
    });
  }
});

function onClassChange(formNode, callback) {
  
  let lastClassString = formNode.classList.toString();

  const mutationObserver = new MutationObserver((mutationList) => {
    for (const item of mutationList) {
      if (item.attributeName === "class") {
        const classString = formNode.classList.toString();
        if (classString !== lastClassString) {
          callback(mutationObserver);
          lastClassString = classString;
          break;
        }
      }
    }
  });

  mutationObserver.observe(formNode, { attributes: true });

  return mutationObserver;
}

$(document).ready(function(){
  $('.header-contact-details a').attr('href', 'tel:1-800-387-0096');
  $('.header-contact-details strong').text('1-800-387-0096');
});